/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';

function FormLabelAndInput({
  className, input, label, name, onChange, placeholder,
  readOnly, type, value
}) {
  return (
    <>
      <div className="form-group">
        <label htmlFor={name}>{label}</label>
        <input
          {...input}
          className={`form-control ${className}`}
          id={name}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          type={type}
          value={value}
        />
      </div>
    </>
  );
}

FormLabelAndInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.element,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

FormLabelAndInput.defaultProps = {
  className: '',
  input: null,
  onChange: () => {},
  placeholder: '',
  readOnly: false,
  value: ''
};

export default FormLabelAndInput;
